// extracted by mini-css-extract-plugin
export default {"example-grid":"thisWeeklyInfo_example-grid__lPWAD","block":"thisWeeklyInfo_block__eeLu6"};